import { createContext, useContext, useState, useCallback } from "react";
import { useEffect } from "react";

import { notificationEvents } from "./notificationEvents";

import { fetchLatestNotifications } from 'services/notifications';


let notificationFetchPromise = null;

const NotificationsContext = createContext();

export function NotificationsProvider({ children }) {
    const [latestNotifications, setLatestNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);

    const fetchNotifications = useCallback(async () => {
        if (!notificationFetchPromise) {
            notificationFetchPromise = fetchLatestNotifications()
                .then((data) => {
                    if (data) {
                        setLatestNotifications(data.data);
                        setUnreadCount(data.unread_count);
                    }
                })
                .finally(() => {
                    notificationFetchPromise = null;
                });
        }

        return notificationFetchPromise;
    }, []);


    useEffect(() => {
        const handler = () => {
            fetchNotifications();
        };

        notificationEvents.on("fetch", handler);

        return () => {
            // no cleanup needed — lightweight
        };
    }, [fetchNotifications]);


    const value = {
        latestNotifications,
        unreadCount,
        setUnreadCount,
        fetchNotifications,
    };

    return (
        <NotificationsContext.Provider value={value}>
            {children}
        </NotificationsContext.Provider>
    );
}

export function useNotifications() {
    return useContext(NotificationsContext);
}
